'use strict';

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

exports['default'] = function (_ref) {
  var messages = _ref.messages;
  var _ref$locale = _ref.locale;
  var locale = _ref$locale === undefined ? 'en' : _ref$locale;
  var children = _ref.children;
  return _react2['default'].createElement(_reactIntl.IntlProvider, { messages: messages, locale: locale, children: children });
};

module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./app/containers/IntlWrapper.jsx
 ** module id = 582
 ** module chunks = 4
 **/